import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { Property } from '@flipdish/orgmanagement';

import SettingsList, { SettingsMenuItem } from '@fd/ui/List/SettingsList';

import { flagService } from '../../../services/flagService/flagService';
import { getPropertySettingsMenuItems } from '../utils';

const PropertySettingsList = ({
  appId,
  property,
  permissions,
}: {
  appId: string;
  property: Property;
  permissions: AppState['permissions'];
}) => {
  const isShowCollectionSettingsAtPropertyLevelOn = useAppSelector((state) =>
    flagService.isFlagOn(state, 'showCollectionSettingsAtPropertyLevel')
  );
  const menuItems = getPropertySettingsMenuItems({
    appId,
    property,
    isShowCollectionSettingsAtPropertyLevelOn,
  });

  const shouldShowAsLast = (item: SettingsMenuItem, index: number) =>
    Boolean(
      index === menuItems.length - 1 ||
        (item.permissions?.includes('EditStores') &&
          !permissions.some((p) => ['Owner', 'FlipdishStaff'].includes(p)))
    );
  return <SettingsList menuItems={menuItems} shouldShowAsLast={shouldShowAsLast} />;
};

export default PropertySettingsList;
